<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="armaForm">
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <div class="text-subtitle-1">Tipo y clase</div>
                </v-col>
                <v-col>
                  <BaseInput
                    label="Número económico"
                    v-model.number="arma.noEconomico"
                    type="number"
                    min="0"
                  ></BaseInput>
                </v-col>
                <v-col>
                  <BaseSelect v-model="selectedTipo" :items="tipoArma">
                    <template v-slot:label>Tipo de arma <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
                <v-col>
                  <BaseSelect v-model="arma.fk_idClase" :items="catalogoTipoArma" :rules="required">
                    <template v-slot:label>Clase de arma <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
                <v-col>
                  <BaseSelect label="Calibre" v-model="arma.fk_idCalibre" :items="calibre" :rules="required">
                    <template v-slot:label>Calibre <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <div class="text-subtitle-1">Marca y modelo</div>
                </v-col>
                <v-col>
                  <BaseSelect
                    label="Marca"
                    v-model="selectedMarca"
                    :items="marcaArma"
                    @change="fetchModeloArmas($event)"
                  >
                    <template v-slot:label>Marca <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
                <v-col>
                  <BaseSelect label="Modelo" v-model="arma.fk_idModelo" :items="catalogoModeloArma" :rules="required">
                    <template v-slot:label>Modelo <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="6">
                  <BaseInput label="Matrícula" v-model="arma.matricula"></BaseInput>
                </v-col>
                <v-col cols="6">
                  <BaseSelect v-model="arma.fk_idCatProcedenciaArma" :items="procedencia" :rules="required">
                    <template v-slot:label>Procedencia <span class="red--text">*</span> </template>
                  </BaseSelect>
                </v-col>
                <v-col cols="4">
                  <BaseInput label="Folio C" v-model="arma.folioC"></BaseInput>
                </v-col>
                <v-col cols="4">
                  <BaseInput label="Folio D" v-model="arma.folioD"></BaseInput>
                </v-col>
                <v-col cols="4">
                  <BaseInput label="Armero" v-model="arma.armeros"></BaseInput>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <BaseInput
                    v-model="arma.fechaAltaLoc"
                    v-mask="'##/##/####'"
                    hint="Formato de fecha: DD/MM/YYYY"
                    :rules="dateRules"
                  >
                    <template v-slot:label>Fecha de alta en LOC <span class="red--text">*</span> </template>
                  </BaseInput>
                </v-col>
                <v-col cols="4">
                  <BaseInput
                    v-model="arma.fechaCompra"
                    v-mask="'##/##/####'"
                    hint="Formato de fecha: DD/MM/YYYY"
                    :rules="dateRules"
                  >
                    <template v-slot:label>Fecha de compra <span class="red--text">*</span> </template>
                  </BaseInput>
                </v-col>
                <v-col cols="4">
                  <BaseInput
                    v-model="arma.puestaDisposición"
                    v-mask="'##/##/####'"
                    hint="Formato de fecha: DD/MM/YYYY"
                    :rules="dateRules"
                  >
                    <template v-slot:label>Fecha de puesta a disposición <span class="red--text">*</span> </template>
                  </BaseInput>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton @click="triggerSaveArma()" :loading="loading" :disabled="!armaForm || loading">
        Registrar arma
      </TextButton>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import BaseSelect from '../../../base/BaseSelect.vue'
import BaseInput from '../../../base/BaseInput.vue'
import TextButton from '../../../base/TextButton.vue'

export default {
  components: {
    BaseSelect,
    BaseInput,
    TextButton,
  },
  data() {
    return {
      registroArmaDialog: false,
      loading: false,
      armaForm: false,

      arma: {
        serie: '',
        folio: '',
        matricula: '',
        noEconomico: 0,
        folioC: '',
        folioD: '',
        loc: '',
        fechaAltaLoc: '',
        fk_idSubsede: null,
        armeros: '',
        fk_idModelo: null,
        fk_idClase: null,
        fk_idCalibre: null,
        fk_idEstatus: null,
        fk_idCatProcedenciaArma: null,
        cantidadCargadores: 0,
        fechaCompra: null,
        puestaDisposición: null,
      },

      selectedTipo: null,
      selectedMarca: null,

      required: [(v) => !!v || 'Este campo es requerido.'],

      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, this.API_DATE_FORMAT)
          return moment(date, this.API_DATE_FORMAT).isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
    }
  },

  computed: {
    ...mapGetters('tipoArma', {
      tipoArma: 'getTipoArmas',
    }),

    ...mapGetters('claseArma', {
      claseArmaCorta: 'getClasesArmaCorta',
      claseArmaLarga: 'getClasesArmaLarga',
    }),

    ...mapGetters('marcaArma', {
      marcaArma: 'getMarcaArma',
    }),

    ...mapGetters('marcaArma', {
      marcaArma: 'getMarcaArma',
    }),

    ...mapGetters('modeloArma', {
      modeloArma: 'getModelosArmas',
      catalogoModeloArma: 'getCatalogoModeloArma',
    }),

    ...mapGetters('calibre', {
      calibre: 'getCalibres',
    }),

    ...mapGetters('estatusArma', {
      estatus: 'getEstatusArma',
    }),

    ...mapGetters('procedencia', {
      procedencia: 'getProcedencia',
    }),

    ...mapGetters('subsede', {
      subsede: 'getSubsedes',
    }),

    filteredClaseArma: function () {
      if (this.selectedTipo) {
        if (this.selectedTipo == 1) {
          return this.claseArmaLarga
        } else return this.claseArmaCorta
      } else return []
    },
    catalogoTipoArma: function () {
      return this.filteredClaseArma.map((tipo) => ({
        id: tipo.id,
        title: tipo.clase,
      }))
    },
  },

  methods: {
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapActions('arma', ['saveArma', 'fetchArmas']),

    closeDialog() {
      this.registroArmaDialog = false

      this.arma = {
        serie: '',
        folio: '',
        matricula: '',
        noEconomico: 0,
        folioC: '',
        folioD: '',
        loc: '',
        fechaAltaLoc: '',
        fk_idSubsede: null,
        armeros: '',
        fk_idModelo: null,
        fk_idClase: null,
        fk_idCalibre: null,
        fk_idEstatus: null,
        fk_idCatProcedenciaArma: null,
        cantidadCargadores: 0,
      }

      this.selectedTipo = null
      this.selectedMarca = null
      this.loading = false
      this.$refs.form.resetValidation()
    },

    async triggerSaveArma() {
      this.loading = true
      await this.saveArma(this.arma)
      await this.fetchArmas()
      this.loading = false
      this.$emit('close')
      this.closeDialog()
    },
  },
}
</script>
